// @flow

export const TOGGLE_DIALOG = '@actionConfirmation/TOGGLE_DIALOG';

export const toggleDialog = (id: string, show: bool) => ({
  type: TOGGLE_DIALOG,
  id,
  show,
});



// WEBPACK FOOTER //
// ./src/actions/actionConfirmation.js